export default __webpack_public_path__ + "static/labrinth-9c1cc1cc5bcc2cf74c7161ebd8960909.png";